import $ from 'jquery';
import _ from 'underscore';
import Backbone from "backbone";
import RSVP from "rsvp";

const CLASSNAME = "DeletionSource";
const DeletionSource =  Backbone.Model.extend({
    idAttribute: "id",

    constructor: function(attributes, options) {
        Backbone.Model.apply(this, [attributes, options]);
    },

    clone: function(){
        return new DeletionSource(this.toJSON());
    },

    getType: function(){
        return this.get("type");
    },
 
    getAppliedInBulk: function(){
        return this.get("appliedInBulk");
    },

    getConstructor : function(){
        return DeletionSource;
    },

    afterInstanceCreatedFromConstructorForCloning : function(createdClonedInstance){

    },

    getSerializedData : function(){
        const serializedData = this.toJSON();
        serializedData.classname =  DeletionSource.CLASSNAME;
        return serializedData;
    },

    restoreFromSerializedData: function(serializedData){
        this.set(serializedData);
    },

    cloneJSON: function(){
        const objJson = {};
        objJson.type = this.getType();
        objJson.classname = DeletionSource.CLASSNAME;
        objJson.appliedInBulk = this.getAppliedInBulk();
        return objJson;
    },


});



DeletionSource.CLASSNAME =  CLASSNAME;
export default DeletionSource; 